import { Component, Node, Sprite, _decorator } from 'cc';
import Lobby from '../../../System/Lobby';
import GameRuleImageViewer from './GameRuleImageViewer';
import ItemGenerator from '../../../../common/scripts/Toolkit/Components/Misc/ItemGenerator';
import NodeName from '../../Data/Config/SceneNodeName';
// import RemoteLoader from '../../../../common/scripts/Toolkit/Helper/Loading/RemoteLoader';

const { ccclass, requireComponent } = _decorator;

@ccclass('GameRuleList')
@requireComponent(ItemGenerator)
export default class GameRuleList extends Component {
    private _imageGenerator: ItemGenerator = null;
    private _imageViewer: GameRuleImageViewer = null;
    private _imageNodeSpriteMap: Map<Node, Sprite> = new Map();
    private _displayMachineID: number;

    private get imageGenerator(): ItemGenerator {
        if (!this._imageGenerator) {
            this._imageGenerator = this.getComponent(ItemGenerator);
        }
        return this._imageGenerator;
    }

    private get imageViewer(): GameRuleImageViewer {
        if (!this._imageViewer) {
            this._imageViewer = Lobby.scene.getNode(NodeName.GameRuleImageViewer).getComponent(GameRuleImageViewer);
        }
        return this._imageViewer;
    }

    protected onLoad(): void {
        this.imageGenerator.on(ItemGenerator.EVENT_TYPE.ITEM_GENERATED, this.onImageGenerated, this);
    }

    protected onEnable(): void {
        // FIX
        // if (this._displayMachineID === FeatureGamecurrentTable.machineID) {
        //     return;
        // }
        // this._displayMachineID = FeatureGamecurrentTable.machineID;
        // FeatureGame.hall.getMachineInfo(this._displayMachineID).then(({ Assets: { Rules: imageURLs } }) => {
        //     this.imageGenerator.displayItemCount = imageURLs.length;
        //     this.imageGenerator.items.forEach((item, index) => {
        //         const sprite = this._imageNodeSpriteMap.get(item);
        //         const imageURL = imageURLs[index];
        //         // clear previous sprite frame before loading finished
        //         sprite.spriteFrame = null;
        //         RemoteLoader.loadSpriteFrame(imageURL).then((spriteFrame) => {
        //             sprite.spriteFrame = spriteFrame;
        //         });
        //     });
        // });
    }

    protected onImageGenerated(image: Node): void {
        const sprite = image.getComponent(Sprite);
        this._imageNodeSpriteMap.set(image, sprite);
        image.on(Node.EventType.TOUCH_END, () => sprite.spriteFrame && this.imageViewer.show(sprite.spriteFrame));
    }
}
